import apiFetch from '../apiFetch'

export default function (values, token) {	
	return apiFetch({endPoint: `AiStation/abrirAiStation`, method: 'POST', body: values, token: token})						
}
